import React from "react";
import {Row, Col} from "react-bootstrap";
import {RBSModal} from "../../base/rbs_components/RBSModal.tsx";
import {RBSTextField} from "../../base/rbs_components/RBSTextField.tsx";
import type {Waterfall} from "../../base/ui_general/GeneralInterfaces.tsx";
import {ValidationSchemes, LabelTextMessageTypes, TextfieldInputTypes} from "../../base/Settings.tsx";
import {getLabelTextMessage} from "../../base/utils/GeneralUtilities.tsx";
import type {InputStateControl} from "../../base/utils/InputStateControl.tsx";
import type {UserLanguages} from "../../base/Settings.tsx";


//TODO: Add multi-language support


/**
 * Props for the WaterfallEditModal component.
 */
interface WaterfallEditModalProps {
    show: boolean;
    waterfall: Waterfall;
    onSubmit: (waterfall: Partial<Waterfall>) => void;
    onClose: () => void;
    isValid: boolean;
    inputStateControl: InputStateControl;
    user_language: UserLanguages;
}

export const WaterfallEditModal: React.FC<WaterfallEditModalProps> = (props) => {
    const {waterfall, inputStateControl, user_language} = props;

    const prefill = (key: keyof Waterfall): string => {
        if (waterfall && waterfall[key] !== undefined && waterfall[key] !== null) {
            return String(waterfall[key]);
        }
        return "";
    };

    const headerTitle = waterfall ? "Update Waterfall" : "Create New Waterfall";

    return (
        <RBSModal
            show={props.show}
            header_title={headerTitle}
            show_close_button
            onClose={props.onClose}
            primary_button_label={getLabelTextMessage(LabelTextMessageTypes.SUBMIT, user_language)}
            secondary_button_label={getLabelTextMessage(LabelTextMessageTypes.CANCEL, user_language)}
            onClickSecondary={props.onClose}
            primary_button_disabled={!props.isValid}
            size="lg"
            onClickPrimary={() => {
                const updatedWaterfall: Waterfall = {
                    ...props.waterfall!,
                    name: inputStateControl.getStringValueForKey("name") || "",
                    description: inputStateControl.getStringValueForKey("description") || "",
                };

                props.onSubmit(updatedWaterfall);
                props.onClose();
            }}
        >
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label={getLabelTextMessage(LabelTextMessageTypes.NAME, props.user_language)}
                        input_key="name"
                        prefill={prefill("name")}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                        input_state_control={inputStateControl}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <RBSTextField
                        label={getLabelTextMessage(LabelTextMessageTypes.DESCRIPTION, props.user_language)}
                        input_key="description"
                        prefill={prefill("description")}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                        input_state_control={props.inputStateControl}
                        type={TextfieldInputTypes.TEXT}
                        multiline={true}
                        style={{minHeight: 300}}
                    />
                </Col>
            </Row>
        </RBSModal>
    );
};
